import { IconButton, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { InputMoney } from '../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../components/RiskRating';
import {
  TableContentItemCaptions,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { messageError } from '../../../../../../../store/batchTicket/constants';

import { AddedProductResponsiveItemFundsProps } from '.';

export const AddedProductItemFundsMobile: React.FC<AddedProductResponsiveItemFundsProps> = ({
  data,
  inputMoneyDataProps,
  minimumMovimentationFormatted,
  onRemoveProduct,
}) => {
  return (
    <VStack w="full">
      <VStack w="full" space={Spacing['inset.nano']}>
        <TableContentItemText variant="bold" fontSize={Typography['fontsize.lg']}>
          {data.productDisplay}
        </TableContentItemText>
        <TableContentItemCaptions forceDesktop icons={data.captions || []} />
      </VStack>
      <VStack space={Spacing['stack.nano']} w={'full'}>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Tipo</TableContentItemText>
          <TableContentItemText>{data.productCategory}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Rent. 12 meses</TableContentItemText>
          <TableContentItemText>
            {Utils.Mask.Percentage(data.profitabilityTwelveMonthsAdjusted)}
          </TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Taxa Admin.</TableContentItemText>
          <TableContentItemText>{data.administrationFee}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Risco</TableContentItemText>
          <RiskRating
            currentRiskRating={data.riskRatingLevel || 0}
            tooltip={data.riskRating || messageError}
          />
        </TableContentItemColumn>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Resgate</TableContentItemText>
          <TableContentItemText>{data.quotationRedemptionTermFormatted}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Aplicação mín.</TableContentItemText>
          <TableContentItemText>{minimumMovimentationFormatted}</TableContentItemText>
        </TableContentItemColumn>
      </VStack>
      <TableContentItemColumn space={Spacing['inline.quarck']} flex={1} w={'full'}>
        <TableContentItemText>Valor a aplicar:</TableContentItemText>
        <HStack w={'full'} alignContent={'center'} space={Spacing['stack.xxxs']}>
          <VStack flex={1}>
            <InputMoney {...inputMoneyDataProps} />
          </VStack>
          <IconButton
            testId="icon-button"
            onPress={onRemoveProduct}
            borderRadius={BoxRadius.sm}
            icon="Trash"
            p={0}
            iconColor={Color['feedback.error.default']}
            iconSize="xs"
          />
        </HStack>
      </TableContentItemColumn>
    </VStack>
  );
};
